import { render } from "./blank.vue?vue&type=template&id=01cc5492&scoped=true"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"

import "./blank.vue?vue&type=style&index=0&id=01cc5492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cc5492"]])

export default __exports__